var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#FFFFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M930 4722 c0 -8 496 -862 508 -874 4 -4 208 193 452 437 l445 445 -703 0 c-386 0 -702 -4 -702 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3230 4285 c244 -244 448 -441 452 -437 12 12 508 866 508 874 0 4 -316 8 -702 8 l-703 0 445 -445z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2105 4230 l-450 -450 905 0 905 0 -450 450 c-247 248 -452 450 -455 450 -3 0 -208 -202 -455 -450z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 4223 c-195 -234 -356 -430 -358 -435 -2 -4 273 -8 612 -8 339 0 616 2 616 4 0 10 -503 866 -509 866 -3 0 -166 -192 -361 -427z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4121 4220 c-138 -238 -251 -433 -251 -436 0 -2 277 -4 615 -4 338 0 615 2 615 5 0 7 -711 859 -720 863 -4 1 -120 -191 -259 -428z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 3442 c1476 -1935 2183 -2860 2185 -2858 1 1 -210 677 -471 1502 l-473 1499 -677 3 -677 2 113 -148z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1553 3578 c2 -7 229 -723 503 -1591 274 -867 501 -1577 504 -1577 3 0 230 710 504 1577 274 868 501 1584 503 1591 4 9 -202 12 -1007 12 -805 0 -1011 -3 -1007 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3765 3578 c-17 -45 -944 -2992 -942 -2994 2 -2 709 922 2185 2858 l113 148 -676 0 c-531 0 -677 -3 -680 -12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.033557ec15c21b0a373039ee52eb8421.svg";
export { ForwardRef as ReactComponent };